import axios from 'axios'

var PhotoApi = {

    getPhoto: function (ori, ccn, nameid, img) {
        if (ccn === null || typeof (ccn) === "undefined" || ori === '' || typeof (ori) === "undefined") {
            img.src = '/images/demophoto1.png';
        }

        img.src = '/images/photoLoadGif.gif';
        var photoUrl = `${process.env.VUE_APP_API_ENDPOINT}/Roster/GetPhoto?ori=${ori}&ccn=${ccn}`;

        axios.get(photoUrl, { responseType: 'arraybuffer' }).then(function (response) {
            var data = response.data;
            var u8 = new Uint8Array(data);

            //var b64encoded = btoa(String.fromCharCode.apply(null, u8));
            var stringChar = u8.reduce((data, byte) => {
                return data + String.fromCharCode(byte)
            }, '');

            var b64encoded = btoa(stringChar);

            var mimetype = 'image/jpg';

            var srcData = `data:${mimetype};base64,${b64encoded}`;
            img.src = srcData;
            img.parentNode.href = photoUrl
            //check for sepecific exception and then
        }).catch(function () {
            img.src = '/images/demophoto1.png';
        });
    },

    //displaySuccessMessage: function (message) {
    //    Notifications.information(sharedVue, 'Success!', message, 6000);
    //},

    //displayErrorMessage: function (message) {
    //    Notifications.error(sharedVue, 'Error!', message, 6000);
    //},
};

export { PhotoApi };